<app-puzzles #puzzlesComponent [_puzzles]="autoGeneratedPuzzles"></app-puzzles>
